import { InstallationBranchMoving } from "@/model/data/InstallationBranchMoving";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/branch/history";

export class GetInstallationBranchHistoryCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: any;

    constructor(installationName: string) {
        super();
        this.params = { installationName: installationName };
    }

    public async execute(): Promise<GetBranchInstallationsResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new GetBranchInstallationsResData(res);
    }
}

export class GetBranchInstallationsResData extends ApiGenericResponse {
    installationBranchMovingList: InstallationBranchMoving[];

    constructor(response: AxiosResponse) {
        super(response);
        this.installationBranchMovingList = [];

        if (
            response.data &&
            response.data.Payload &&
            Array.isArray(response.data.Payload.InstallationBranchMovingList) &&
            response.data.Payload.InstallationBranchMovingList.length
        )
            this.parse(response.data.Payload.InstallationBranchMovingList);
    }

    public parse(installationBranchMovingList: any) {
        installationBranchMovingList.forEach((installationBranchMoving) => {
            var moving: InstallationBranchMoving = new InstallationBranchMoving();
            moving.parse(installationBranchMoving);
            if (moving) this.installationBranchMovingList.push(moving);
        });
    }
}
